import styles from "./index.module.scss";
import { IImportants } from "../../types/INote";

export default function ImportantNotes({
  setLoadMore,
  setClickedNoteId,
  importants,
  isMobile,
}: {
  setLoadMore: React.Dispatch<React.SetStateAction<boolean>>;
  setClickedNoteId: React.Dispatch<React.SetStateAction<string | undefined>>;
  importants: IImportants[];
  isMobile: boolean;
}): JSX.Element {
  const onClickHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>, id: string) => {
    event.preventDefault();
    setClickedNoteId(id);
    setLoadMore(true);
  };

  return (
    <div className={[styles.important, isMobile ? styles.mobile : ""].join(" ")} data-e="notes-importants">
      <div className={styles.important__mainTitle}>Najważniejsze</div>
      <ul className={styles.important__list}>
        {importants?.map((note: IImportants) => (
          <li className={styles.important__item} key={`note-item-${note.id}`}>
            <a
              href={`#${note.id}`}
              className={styles.important__title}
              onClick={(event) => onClickHandler(event, note.id)}
              rel="nofollow"
            >
              {note.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
